/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Fixed_Weekdays_QuestionInputs */

const en_us2_onboarding_fixed_weekdays_question = /** @type {(inputs: Onboarding_Fixed_Weekdays_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which days?`)
};

const pt_br2_onboarding_fixed_weekdays_question = /** @type {(inputs: Onboarding_Fixed_Weekdays_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais dias?`)
};

const es_419_onboarding_fixed_weekdays_question = /** @type {(inputs: Onboarding_Fixed_Weekdays_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué días?`)
};

const pt_pt2_onboarding_fixed_weekdays_question = /** @type {(inputs: Onboarding_Fixed_Weekdays_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dias?`)
};

const fr_fr2_onboarding_fixed_weekdays_question = /** @type {(inputs: Onboarding_Fixed_Weekdays_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels jours ?`)
};

const de_de2_onboarding_fixed_weekdays_question = /** @type {(inputs: Onboarding_Fixed_Weekdays_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Tage?`)
};

const it_it2_onboarding_fixed_weekdays_question = /** @type {(inputs: Onboarding_Fixed_Weekdays_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali giorni?`)
};

/**
* | output |
* | --- |
* | "Which days?" |
*
* @param {Onboarding_Fixed_Weekdays_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_fixed_weekdays_question = /** @type {((inputs?: Onboarding_Fixed_Weekdays_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Fixed_Weekdays_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_fixed_weekdays_question(inputs)
	if (locale === "es-419") return es_419_onboarding_fixed_weekdays_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_fixed_weekdays_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_fixed_weekdays_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_fixed_weekdays_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_fixed_weekdays_question(inputs)
	return en_us2_onboarding_fixed_weekdays_question(inputs)
});
export { onboarding_fixed_weekdays_question as "onboarding.fixed_weekdays.question" }